/**
 * ResultLink Component
 */

import { linkWithQueryString } from '../../../../utils/router';
import { stripHTMLTagsFromString } from '../../../../utils/string';

import { withRouter } from 'found';
import * as React from 'react';
import * as BEM from 'react-bem-helper';

import Button, { ButtonProps } from '../../../atoms/buttons/Button';
import { ArtistPagePath } from '../../../pages/Artist';
import { TrackPagePath } from '../../../pages/Track';

export interface IResultLinkProps extends Pick<ButtonProps, 'hyperLinkProps' | 'onClick' | 'wrapperComponent'> {
  className: string;
  label: string;
}

export class ResultLink extends React.PureComponent<IResultLinkProps> {

  render() {
    const {
      className,
      label,
      ...buttonProps
    } = this.props;

    const classes = new BEM(this.props.className);

    return (
      <Button
        variant="hyperlink"
        label={typeof label === 'string' ? stripHTMLTagsFromString(label) : label}
        size="large"
        {...buttonProps}
        {...classes()}
      />
    );
  }
}

interface IResultLinkPageProps extends IResultLinkProps {
  slug: string;
}

export const ResultLinkArtist = withRouter<IResultLinkPageProps>(({
  className,
  label,
  slug,
  ...props
}) => (
  <ResultLink
    className={className}
    label={label}
    wrapperComponent="a"
    hyperLinkProps={{
      href: linkWithQueryString(ArtistPagePath(slug), props.match.location.query),
      target: '_blank',
    }}
  />
));

export const ResultLinkTrack = withRouter<IResultLinkPageProps>(({
  className,
  label,
  slug,
  ...props
}) => (
  <ResultLink
    className={className}
    label={label}
    wrapperComponent="a"
    hyperLinkProps={{
      href: linkWithQueryString(TrackPagePath(slug), props.match.location.query),
      target: '_blank',
    }}
  />
));



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/organisms/global/InstantSearch/ResultLink.tsx